import { ChevronRight } from 'lucide-react';
import { useState, type ReactNode } from 'react';

export function AppModelSection({
  label,
  initiallyExpanded,
  renderHeader,
  slots
}: {
  label: string;
  initiallyExpanded: boolean;
  renderHeader: (label: ReactNode) => ReactNode;
  slots: ReactNode[];
}) {
  const [expanded, setExpanded] = useState(initiallyExpanded);
  const toggle =
    slots.length > 0 ? (
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
        className="inline-flex items-center gap-2 text-left"
      >
        <ChevronRight
          className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform ${expanded ? 'rotate-90' : ''}`}
        />
        {label}
      </button>
    ) : (
      // Lines the name up with the names behind a chevron.
      <span className="pl-6">{label}</span>
    );
  return (
    <div className="space-y-4">
      {renderHeader(toggle)}
      {expanded && slots.length > 0 && <div className="pl-12 space-y-4">{slots}</div>}
    </div>
  );
}
